__turbopack_context__.v({
  "buttonAlignment": "ContactForm-module__uhxGha__buttonAlignment",
  "contactFormAllSectionContentAlignment": "ContactForm-module__uhxGha__contactFormAllSectionContentAlignment",
  "contactFromAlignment": "ContactForm-module__uhxGha__contactFromAlignment",
  "formDetailsAlignment": "ContactForm-module__uhxGha__formDetailsAlignment",
  "formDetailsHeadingAlignment": "ContactForm-module__uhxGha__formDetailsHeadingAlignment",
  "formFridItemAlignment": "ContactForm-module__uhxGha__formFridItemAlignment",
  "formGridAlignment": "ContactForm-module__uhxGha__formGridAlignment",
  "iconBoxALignment": "ContactForm-module__uhxGha__iconBoxALignment",
  "inputAlignment": "ContactForm-module__uhxGha__inputAlignment",
  "rightAngleFirstImg": "ContactForm-module__uhxGha__rightAngleFirstImg",
  "rightAngleSecondImg": "ContactForm-module__uhxGha__rightAngleSecondImg",
  "secondDetailsAlignment": "ContactForm-module__uhxGha__secondDetailsAlignment",
});
